import Vue from "vue";
import "./plugins/axios";
import "./plugins/swiper";
import App from "./App.vue";

import router from "./router/router";
import store from "./store/store";
import i18n from "./i18n";
//import "./registerServiceWorker";

Vue.config.productionTip = false;

const _hmt = _hmt || [];
window._hmt = _hmt;
const tongji = () => {
  (function() {
    if (document.getElementById("tongji")) {
      document.body.removeChild(document.getElementById("tongji"));
    }

    var hm = document.createElement("script");
    hm.src = "https://hm.baidu.com/hm.js?24b0fb356c67dd7f9847fc84d8661763";
    hm.id = "tongji";
    var s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(hm, s);
  })();
};

router.beforeEach((to, from, next) => {
  if (_hmt) {
    if (to.path) {
      tongji();
      _hmt.push(["_trackPageview", "/m/#" + to.fullPath]);
    }
  }
  next();
});

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
